import React from "react";
import { Row, Col } from "reactstrap";

import { IconCheckbox } from "components";

class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerType: this.props.wizardData.wizardState.customerType
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(field, value) {
    let auxState = this.state;
    auxState[field] = value;
    this.setState(auxState);

    this.props.wizardData.onChange(field, value);
  }

  isValidated() {
    if (this.props.wizardData.wizardState.customerType === "") {
      return false;
    }
    return true;
  }

  render() {
    return (
      <div>
        <h5 className="info-text"> Selecciona el tipo de cliente</h5>
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <Row>
              <Col xs={12} sm={3}>
                <IconCheckbox
                  name="customerType"
                  value="89"
                  icon="now-ui-icons users_single-02"
                  title="Particular"
                  isActive={this.state.customerType === "89"}
                  onChange={this.onChange}
                  wizardState={this.props.wizardData.wizardState}
                />
              </Col>
              <Col xs={12} sm={3}>
                <IconCheckbox
                  name="customerType"
                  value="91"
                  icon="now-ui-icons business_briefcase-24"
                  title="Autónomo"
                  isActive={this.state.customerType === "91"}
                  onChange={this.onChange}
                  wizardState={this.props.wizardData.wizardState}
                />
              </Col>
              <Col xs={12} sm={3}>
                <IconCheckbox
                  name="customerType"
                  value="90"
                  icon="now-ui-icons business_badge"
                  title="Empresa"
                  isActive={this.state.customerType === "90"}
                  onChange={this.onChange}
                  wizardState={this.props.wizardData.wizardState}
                />
              </Col>
              <Col xs={12} sm={3}>
                <IconCheckbox
                  name="customerType"
                  value="92"
                  icon="now-ui-icons business_globe"
                  title="Extranjero"
                  isActive={this.state.customerType === "92"}
                  onChange={this.onChange}
                  wizardState={this.props.wizardData.wizardState}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerWizard/CustomerType.jsx